import { useDispatch, useSelector } from 'app-redux'
import { PublishBitrates } from 'common/publish-bitrates'
import { RootState } from 'common/redux'
import { TrainingRoomPhase } from 'common/types'
import { selectParam } from 'features/param-toggler/param-toggler-redux'
import { useEffect } from 'react'
import { selectFocusedFeature } from 'room/training-room/redux'
import {
	othersStream,
	selectLocalScreenShareStream,
	selectPublishBitRate,
	setPublishBitrate,
} from 'video-conference-media/redux'

export const useBitrate = (): void => {
	const dispatch = useDispatch()
	const trainingRoomPhase = useSelector(
		(state: RootState) => state.room.trainingRoomPhase
	)
	const focusedFeature = useSelector(selectFocusedFeature)
	const sceneVideoUsers = useSelector(othersStream)
	const userCount = sceneVideoUsers.length
	const currentBitrate = useSelector(selectPublishBitRate)
	const isLocalScreenShare = !!useSelector(selectLocalScreenShareStream)
	const recordingParam = useSelector(state => selectParam(state, 'recording'))

	const showingFocusedFeature =
		focusedFeature && trainingRoomPhase === TrainingRoomPhase.INITIAL

	useEffect(() => {
		let bitrate = PublishBitrates.low
		if (recordingParam === true || recordingParam === 'true') {
			bitrate = PublishBitrates.ultra4k
		} else if (userCount === 0) {
			//Nobody else in the room, no need to stream high quality
			bitrate = PublishBitrates.low
		} else if (isLocalScreenShare) {
			bitrate = PublishBitrates.screenShare
		} else if (
			!showingFocusedFeature &&
			trainingRoomPhase === TrainingRoomPhase.INITIAL
		) {
			bitrate = PublishBitrates.high
		}

		if (bitrate !== currentBitrate) {
			dispatch(setPublishBitrate(bitrate))
		}
	}, [
		dispatch,
		currentBitrate,
		isLocalScreenShare,
		showingFocusedFeature,
		trainingRoomPhase,
		userCount,
		recordingParam,
	])
}
